import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
const initialState = {
RespiratoryRateUpperRed:null,
RespiratoryRateUpperYellow:null,
RespiratoryRateMiddle1:null,
RespiratoryRateMiddle2:null,
RespiratoryRateLowerYellow:null,
RespiratoryRateLowerRed:null,
O2SaturationUpperRed:null,
O2SaturationUpperYellow:null,
O2SaturationMiddle1:null,
O2SaturationMiddle2:null,
O2SaturationLowerYellow:null,
O2SaturationLowerRed:null,
O2FlowRateUpperRed:null,
O2FlowRateUpperYellow:null,
O2FlowRateMiddle1:null,
O2FlowRateMiddle2:null,
O2FlowRateLowerYellow:null,
O2FlowRateLowerRed:null,
SystolicBloodPressureUpperRed:null,
SystolicBloodPressureUpperYellow:null,
SystolicBloodPressureMiddle1:null,
SystolicBloodPressureMiddle2:null,
SystolicBloodPressureLowerYellow:null,
SystolicBloodPressureLowerRed:null,
HeartRateUpperRed:null,
HeartRateUpperYellow:null,
HeartRateMiddle1:null,
HeartRateMiddle2:null,
HeartRateLowerYellow:null,
HeartRateLowerRed:null,
TemperatureUpperRed:null,
TemperatureUpperYellow:null,
TemperatureMiddle1:null,
TemperatureMiddle2:null,
TemperatureLowerYellow:null,
TemperatureLowerRed:null,
ShowImg:false,
DeleteAlteredcallingcriteriaImage:false,
DeleteTreatmentLimitingOrderPhoto:false,
DeleteTraumachartPhoto:false,
DeleteAddPhotoOfCardiacTrace:false,
setPdfname:null,
appId:null,
isApp:false,
}
const pcrSlice = createSlice({
    name: 'pcrStore',
    initialState,
    reducers: {
        setpcrstate(state: any, action: PayloadAction<any>) {
            state[action.payload.name] = action.payload.value
        }
    }
})
export const { setpcrstate } = pcrSlice.actions;
export default pcrSlice.reducer;
export const pcrstate = (state:RootState) => state.pcrSlice 